import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-last-page',
  templateUrl: './last-page.component.html',
  styleUrls: ['./last-page.component.css']
})
export class LastPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
